import { useEffect, useState } from "react";

function calc(dateStr) {
  if (!dateStr) return null;
  const target = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(target.getTime())) return null;
  const ms = target.getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / 86400000));
}

/** Whole days from now until dateStr ("YYYY-MM-DD"); refreshes hourly. */
export default function useDaysUntil(dateStr) {
  const [days, setDays] = useState(() => calc(dateStr));
  useEffect(() => {
    setDays(calc(dateStr));
    const id = setInterval(() => setDays(calc(dateStr)), 60 * 60 * 1000);
    return () => clearInterval(id);
  }, [dateStr]);
  return days;
}
